import { render, staticRenderFns } from "./singleMenuItem.vue?vue&type=template&id=f009b772&scoped=true"
import script from "./singleMenuItem.vue?vue&type=script&lang=js"
export * from "./singleMenuItem.vue?vue&type=script&lang=js"
import style0 from "./singleMenuItem.vue?vue&type=style&index=0&id=f009b772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f009b772",
  null
  
)

export default component.exports